import React, { useEffect, useState } from "react";
import "./CheckInputForm.css";
import { styled } from "@mui/material/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import LoaderVWC from "../components/LoaderVWC";
import PersonIcon from "@mui/icons-material/Person";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import WarningIcon from "@mui/icons-material/Warning";
import AddBoxIcon from "@mui/icons-material/AddBox";
import TaskIcon from "@mui/icons-material/Task";
import InfoIcon from "@mui/icons-material/Info";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import DomainVerificationIcon from "@mui/icons-material/DomainVerification";
import {
  Button,
  TextField,
  Checkbox,
  FormControlLabel,
  Divider,
  FormLabel,
} from "@mui/material";
import LanguageSelect from "../components/LanguageSelect";
import Error from "../components/Error";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Trans, useTranslation } from "react-i18next";
import TranslateIcon from "@mui/icons-material/Translate";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
});

const FormWH = ({
  inputData,
  setInputData,
  startRun,
  runLoading,
  runError,
}) => {
  const [isSummaryView, setIsSummaryView] = useState(false);
  const [hideError, setHideError] = useState(false);
  const theme = useTheme();
  const { t, i18n } = useTranslation();

  const mobile = useMediaQuery(theme.breakpoints.between("mobile", "ipad"));

  function handleResetForm() {
    setHideError(true);
    setIsSummaryView(false);
  }

  function startRunHandler() {
    setHideError(false);
    startRun();
  }

  function isPdf(file) {
    if (!file) return false;

    const isPdfExtension = file.name.toLowerCase().endsWith(".pdf");
    const isPdfMimeType = file.type === "application/pdf";

    return isPdfExtension && isPdfMimeType;
  }

  return (
    <div className="nc-form">
      <div className="nc-form-input">
        <span className="nc-form-title">{t("module.Arbeidsovereenkomst")}</span>
        <span className="nc-form-subtitle">
          {isSummaryView ? (
            <span>{t("controleerJeGegevensText")}</span>
          ) : (
            <span>{t("fillOutYourDetails")}</span>
          )}
        </span>
        <Divider sx={{ width: "100%", marginBottom: "24px" }} />
        <div className="nc-form-main">
          {!isSummaryView && (
            <React.Fragment>
              <div className="nc-inputs">
                <span className="nc-inputs-title">
                  <PersonIcon sx={{ color: "#439BD9" }} />
                  {t("persoonlijkeGegevens")}
                </span>
                <div className="nc-textfields">
                  <TextField
                    label={t("naam")}
                    variant="outlined"
                    value={inputData?.name || ""}
                    onChange={(e) =>
                      setInputData({ ...inputData, name: e.target.value })
                    }
                    required
                    sx={{
                      backgroundColor: "#F9FCFE",
                      border: "1px solid #ECF5FD",
                    }}
                  />
                  <TextField
                    label="Email"
                    email
                    variant="outlined"
                    value={inputData?.email || ""}
                    onChange={(e) =>
                      setInputData({ ...inputData, email: e.target.value })
                    }
                    required
                    sx={{
                      backgroundColor: "#F9FCFE",
                      border: "1px solid #ECF5FD",
                    }}
                  />
                </div>
                <span
                  className="nc-inputs-title"
                  style={{ marginBottom: "-16px", marginTop: "24px" }}
                >
                  <UploadFileIcon sx={{ color: "#439BD9" }} />
                  Upload {t("arbeidsovereenkomst")}
                </span>

                <div className="nc-upload-container">
                  <div className="nc-upload-field mb-1">
                    {inputData.contractFile ? (
                      <div className="nc-file-details">
                        <span className="nc-upload-file">
                          {inputData?.contractFile?.name || ""}
                        </span>
                        <DeleteIcon
                          onClick={() =>
                            setInputData({ ...inputData, contractFile: null })
                          }
                          sx={{ cursor: "pointer", color: "#0F3A58" }}
                        />
                      </div>
                    ) : (
                      <div>
                        <span>{t("bestandsFormaat")}: PDF, DOCX</span>
                        <br />
                        <br />
                        <Button
                          component="label"
                          color="primary"
                          role={undefined}
                          variant="contained"
                          tabIndex={-1}
                          sx={{
                            border: "2px dashed #2484C848",
                            borderRadius: "8px",
                            padding: "24px",
                            minHeight: "120px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "#F9FCFE",
                            backgroundImage: `repeating-linear-gradient(
                            transparent,
                            transparent 8px,
                            #439BD9 8px,
                            #439BD9 12px,
                          )`,
                            width: "120px",
                            backgroundSize: "2px 3px",
                            backgroundPosition:
                              "top left, top right, bottom right, bottom left",
                          }}
                          // disabled={selectedModule === null}
                          startIcon={
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                color: "#000",
                                transform: "translateX(4px)",
                              }}
                            >
                              <UploadFileIcon
                                htmlColor="#439BD9"
                                sx={{ marginRight: "0!important" }}
                              />
                              <span
                                style={{
                                  fontSize: "12px",
                                  color: "#439BD9",
                                  fontWeight: 500,
                                  textTransform: "none",
                                }}
                              >
                                Upload
                              </span>
                            </div>
                          }
                        >
                          <VisuallyHiddenInput
                            type="file"
                            accept=".pdf,.docx"
                            onChange={(e) =>
                              setInputData({
                                ...inputData,
                                contractFile: e.target.files[0],
                              })
                            }
                          />
                        </Button>
                      </div>
                    )}
                  </div>

                  {isPdf(inputData?.contractFile) && (
                    <React.Fragment>
                      <span className="nc-inputs-title">
                        <AddBoxIcon sx={{ color: "#439BD9" }} />
                        {t("aanvullendeVragen")}
                      </span>
                      <div className="nc-checkboxes">
                        <FormLabel
                          sx={{
                            fontSize: "16px",
                            fontWeight: "400",
                            margin: "12px 0",
                          }}
                        >
                          <span>{t("isGescandVraag")}</span>
                        </FormLabel>
                        <RadioGroup
                          row={mobile ? false : true}
                          value={inputData?.isScanned}
                          onChange={(e) => {
                            setInputData({
                              ...inputData,
                              isScanned: e.target.value,
                            });
                          }}
                        >
                          <FormControlLabel
                            value="YES"
                            control={<Radio />}
                            label={t("ja")}
                          />
                          <FormControlLabel
                            value="NO"
                            control={<Radio />}
                            label={t("nee")}
                          />
                          <FormControlLabel
                            value="UNKNOWN"
                            control={<Radio />}
                            label={t("weetIkNiet")}
                          />
                        </RadioGroup>
                        <FormLabel
                          sx={{
                            fontSize: "16px",
                            margin: "12px 0",
                            fontWeight: "400",
                          }}
                        >
                          <span>{t("isDoorgehaaldVraag")}</span>
                        </FormLabel>
                        <RadioGroup
                          row={mobile ? false : true}
                          value={inputData?.hasStrikethrough}
                          onChange={(e) => {
                            setInputData({
                              ...inputData,
                              hasStrikethrough: e.target.value,
                            });
                          }}
                        >
                          <FormControlLabel
                            value="YES"
                            control={<Radio />}
                            label={t("ja")}
                          />
                          <FormControlLabel
                            value="NO"
                            control={<Radio />}
                            label={t("nee")}
                          />
                          <FormControlLabel
                            value="UNKNOWN"
                            control={<Radio />}
                            label={t("weetIkNiet")}
                          />
                        </RadioGroup>
                      </div>
                    </React.Fragment>
                  )}
                </div>

                {/* <span
                  className="nc-inputs-title"
                >
                  <TranslateIcon sx={{ color: "#439BD9" }} />
                  {t("gewensteTaal")}
                </span>
                <div className="nc-textfields">

                <LanguageSelect handleSelectLanguage={(e) =>  setInputData({ ...inputData, language: e })} />
                </div> */}
                {inputData.hasTerms && (
                  <div className="nc-upload-container">
                    <div className="nc-upload-field mb-1">
                      <Button
                        component="label"
                        color="secondary"
                        role={undefined}
                        variant="contained"
                        tabIndex={-1}
                        sx={{
                          border: "2px dashed #2484C848",
                          borderRadius: "8px",
                          padding: "24px",
                          minHeight: "120px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "#F9FCFE",
                          backgroundImage: `repeating-linear-gradient(
                            transparent,
                            transparent 8px,
                            #439BD9 8px,
                            #439BD9 12px,
                          )`,
                          width: "120px",
                          backgroundSize: "2px 3px",
                          backgroundPosition:
                            "top left, top right, bottom right, bottom left",
                        }}
                        // disabled={selectedModule === null}
                        startIcon={
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                              color: "#000",
                              transform: "translateX(4px)",
                            }}
                          >
                            <UploadFileIcon
                              htmlColor="#439BD9"
                              sx={{ marginRight: "0!important" }}
                            />
                            <span
                              style={{
                                fontSize: "12px",
                                color: "#439BD9",
                                fontWeight: 500,
                                textTransform: "none",
                              }}
                            >
                              Upload
                            </span>
                          </div>
                        }
                      >
                        <VisuallyHiddenInput
                          type="file"
                          onChange={(e) =>
                            setInputData({
                              ...inputData,
                              termsFile: e.target.files[0],
                            })
                          }
                        />
                      </Button>
                    </div>
                  </div>
                )}
              </div>

              <div className="disclaimer-container">
                <div className="nc-textfields">
                  <span className="nc-inputs-title">
                    <VpnKeyIcon sx={{ color: "#439BD9" }} />
                    {t("toegangscode")}
                  </span>
                  <TextField
                    label={t("toegangscode")}
                    variant="outlined"
                    value={inputData?.accessCode || ""}
                    onChange={(e) =>
                      setInputData({
                        ...inputData,
                        accessCode: e.target.value,
                      })
                    }
                    required
                    sx={{
                      backgroundColor: "#F9FCFE",
                      border: "1px solid #ECF5FD",
                    }}
                  />
                  <div
                    className="flex"
                    style={{ margin: mobile ? "auto" : "12px 0" }}
                  >
                    <em style={{ fontSize: "14px", color: "#454545" }}>
                      <Trans
                        i18nKey="testDisclaimerShort"
                        components={{ bold: <strong /> }}
                      />
                    </em>
                  </div>
                </div>

                <div className="disclaimer-content">
                  <span
                    className="nc-inputs-title"
                    style={{ marginBottom: "-16px" }}
                  >
                    <WarningIcon sx={{ color: "#439BD9" }} />
                    Disclaimer
                  </span>

                  <p style={{ fontFamily: "Lato" }}>
                    {t("testDisclaimerLong")}
                    <br />
                    <br />
                    {t("testDisclaimerLong2")}
                  </p>
                  <span
                    className="nc-inputs-title"
                    style={{ marginBottom: "-16px" }}
                  >
                    {t("toestemming")}
                  </span>
                  <div className="nc-checkboxes">
                    <FormControlLabel
                      control={<Checkbox />}
                      label={
                        i18n.language === "nl" ? (
                          <Trans
                            i18nKey="avwAkkoord"
                            components={{
                              avw: (
                                <a
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  href="https://voorwaardenchecker.nl/nl/algemene-voorwaarden"
                                >
                                  Algemene Voorwaarden
                                </a>
                              ),
                              privacyverklaring: (
                                <a
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  href="https://voorwaardenchecker.nl/nl/privacyverklaring"
                                >
                                  Privacyverklaring
                                </a>
                              ),
                            }}
                          />
                        ) : (
                          <Trans
                            i18nKey="avwAkkoord"
                            components={{
                              avw: (
                                <a
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  href="https://checkyourterms.com/en/terms-and-conditions"
                                >
                                  Terms and Conditions
                                </a>
                              ),
                              privacyverklaring: (
                                <a
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  href="https://checkyourterms.com/en/privacy-statement"
                                >
                                  Privacy statement
                                </a>
                              ),
                            }}
                          />
                        )
                      }
                      checked={inputData?.agreed}
                      onChange={(e) =>
                        setInputData({ ...inputData, agreed: e.target.checked })
                      }
                    />
                    <FormControlLabel
                      control={<Checkbox />}
                      label={t("disclaimerGelezen")}
                      checked={inputData?.disclaimerAgreed}
                      onChange={(e) =>
                        setInputData({
                          ...inputData,
                          disclaimerAgreed: e.target.checked,
                        })
                      }
                    />
                  </div>
                </div>

                <div className="proceed-btn">
                  <Button
                    variant="contained"
                    color="secondary"
                    sx={{
                      color: "#fff",
                      borderRadius: "40px",
                      textTransform: "none",
                    }}
                    onClick={() => setIsSummaryView(true)}
                    disabled={
                      inputData?.agreed === false ||
                      inputData?.disclaimerAgreed === false ||
                      inputData?.contractFile === null ||
                      inputData?.accessCode === ""
                    }
                  >
                    {t("bevestigen")}
                  </Button>
                </div>
              </div>
            </React.Fragment>
          )}
          {isSummaryView && (
            <React.Fragment>
              <div className="nc-summary">
                <span className="nc-inputs-title mb-1">
                  <TaskIcon sx={{ color: "#439BD9" }} />
                  {t("samenvatting")}
                </span>
                <div className="nc-summary">
                  <div className="nc-summary-row">
                    <label>{t("naam")}</label>
                    <span>{`${inputData?.name || ""}`}</span>
                  </div>
                  <div className="nc-summary-row">
                    <label>E-mail</label>
                    <span>{inputData?.email || ""}</span>
                  </div>
                  <div className="nc-summary-row">
                    <label>{t("taal")}</label>
                    <span>{inputData?.language || ""}</span>
                  </div>
                  {/* <div className="nc-summary-row">
                    <label>{t("heeftDoorgehaaldeTekst")}</label>
                    <span>
                      {inputData?.hasStrikethrough ? t("ja") : t("nee")}
                    </span>
                  </div> */}
                  <div className="nc-summary-row">
                    <label>{t("Huurovereenkomst")}</label>
                    <span>
                      {inputData.contractFile
                        ? inputData?.contractFile.name
                        : "Geen bestand"}
                    </span>
                  </div>
                  <div className="nc-summary-row">
                    <label>{t("toegangscode")}</label>
                    <span>{inputData?.accessCode || ""}</span>
                  </div>
                  {/* <div className="nc-summary-row">
                    <label>Algemene voorwaarden huurcontract</label>
                    <span>
                      {inputData.contractFile
                        ? inputData?.termsFile?.name
                        : "(Geen)"}
                    </span>
                  </div> */}
                </div>
              </div>
              <div className="nc-summary-confirm">
                <div className="disclaimer-content">
                  {runLoading ? (
                    <div className="run-loading">
                      <LoaderVWC inline message={t("checkInUitvoering")} />
                    </div>
                  ) : runError && hideError === false ? (
                    <React.Fragment>
                      <Error statusCode={runError.status} detail={runError} />
                      <Button
                        variant="contained"
                        sx={{
                          color: "#439BD9",
                          backgroundColor: "#D7E9F7",
                          borderRadius: "40px",
                          textTransform: "none",
                          width: "100px",
                        }}
                        onClick={handleResetForm}
                      >
                        {t("terug")}
                      </Button>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span className="nc-inputs-title">
                        <DomainVerificationIcon sx={{ color: "#439BD9" }} />
                        {t("checkStarten")}
                      </span>
                      <p style={{ fontFamily: "Lato" }}>
                        {t("allesIngevuldVraag")}
                      </p>
                      <div className="start-check-btns">
                        <Button
                          variant="contained"
                          sx={{
                            color: "#439BD9",
                            backgroundColor: "#D7E9F7",
                            borderRadius: "40px",
                            textTransform: "none",
                          }}
                          onClick={() => setIsSummaryView(false)}
                        >
                          {t("terug")}
                        </Button>
                        <Button
                          variant="contained"
                          color="secondary"
                          sx={{
                            color: "#fff",
                            borderRadius: "40px",
                            textTransform: "none",
                          }}
                          onClick={startRunHandler}
                        >
                          {t("starten")}
                        </Button>
                      </div>
                    </React.Fragment>
                  )}
                </div>
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
    </div>
  );
};

export default FormWH;
